import React, { Component } from 'react'
import {
  Button,
  Layout,
  Row,
  Col,
  Input,
  message
} from "antd";
import connect from "react-redux/es/connect/connect";
import { hashHistory } from "react-router";

import PageHeader from "../../components/Modules/PageHeader";
import FilterPanel from "../../components/Modules/FilterPanel";
import Chat from "../../components/Modules/Chat";
import AskForLogin from '../../components/Modules/AskForLogin';

import {
  getChatAction,
  getUserChatsAction,
  sendChatMessageAction,
  moderateChatsAction,
  updateChatStatusAction
} from "../../actions/chatStoreActions";
import { makeChatFavorite } from "../../actions/userStoreActions";
import { getAllChatsOfUserListener } from "../../services/firebase/chats";
import { auth } from '../../services/firebase/firebase';

import ContactList from '../../components/Modules/ContactList';

import './messages.less'

const { Search } = Input;
const { Content } = Layout;

class Messages extends Component {
  constructor(props){
    super(props);
    this.state = {
      user: null,
      activeChat: false,
      userClaims: {},
      chatId: props.params.id,
      chats: [],
      visibleRegistration: false,
      visibleAuth: true,
      activeType: 'auth',
      filter: '',
      viewType: 'all'
    };
  }

  static getDerivedStateFromProps(props, state) {
    const { userClaims } = props.user;

    if (userClaims !== state.userClaims || props.params.id !== state.chatId) {
      if (props.params.id && userClaims.user_id) {
        props.getChatAction(props.params.id, userClaims.user_id);
      }
      userClaims.user_id && props.getUserChatsAction(userClaims.user_id);

      return {
        userClaims: userClaims,
        chatId: props.params.id
      };
    }

    return null;
  }

  componentDidMount() {
    getAllChatsOfUserListener(this.callbackAllChatsOfUserListener)
  };

  callbackAllChatsOfUserListener(chats) {
    const { userClaims } = this.props.user;
    this.props.moderateChatsAction(chats, userClaims.user_id)
  };

  handleChatChange(chatId) {
    const { uid } = this.props.user;
    const { allChats } = this.props.data;
    let needToUpdate = false;

    if (this.props.params.id !== chatId) {
      this.setState({ activeChat: true });

      const index = allChats.findIndex(chat => {
        return chat.chatId === chatId;
      });
      const isNumber = typeof index === 'number' && !isNaN(index);
      isNumber && allChats[index].chat.forEach(message => {
        if (message.unread && message.userId !== uid) {
          needToUpdate = true;
        }
      });

      needToUpdate && this.updateChat(allChats, chatId);

      hashHistory.push(`/Messages/${chatId}`);
    }
  };

  updateChat(chat, chatId) {
    const { user, updateChatStatusAction } = this.props;
    const { uid } = user;

    const index = chat.findIndex(function(element){
      return element.chatId === chatId;
    });

    const chatDetails = chat[index];
    const updatedChat = chatDetails.chat.map(message => {
      if (message.userId !== uid && message.unread) {
        return {
          ...message,
          unread: false
        }
      }
      return message;
    });
    updateChatStatusAction(updatedChat, chatId);
  };

  setStateHandler = (obj) => {
    this.setState(obj)
  };

  activeChatHandler = () => {
    this.setState(prevState => {
      return {
        activeChat: !prevState.activeChat
      }
    });

    hashHistory.push(`/Messages`);
  };

  handleContactFilter(event) {
    const value = event.target.value.toLowerCase();

    this.setState({
      filter: value
    });
  };

  handleViewTypeChange() {
    this.setState(prevState => {
      const viewType = prevState.viewType === 'all'
        ? 'favorite' : 'all';

      return {
        viewType: viewType
      }
    });
  }

  safeTofavoriteSwitcher(chatId) {
    const uid = auth().currentUser.uid;
    const { favoriteChats, saveLoadingOptions } = this.props.user;
    const { messageType, error } = saveLoadingOptions;
    const { makeChatFavorite } = this.props;

    let newFavoriteChats = [...favoriteChats];
    let favoriteTypeAction;

    if (newFavoriteChats.indexOf(chatId) === -1) {
      favoriteTypeAction = 'add';
      newFavoriteChats = [...newFavoriteChats, chatId];
    } else {
      favoriteTypeAction = 'delete';
      newFavoriteChats = favoriteChats.filter(event => event !== chatId);
    }

    makeChatFavorite({uid: uid, newFavoriteChats: newFavoriteChats});

    if (messageType && messageType === 'success') {
      const messageText = favoriteTypeAction === 'add' ?
        'Chat is added to favorites' :
        'Chat is removed from favorites';
      return message.success(messageText);
    }
    if (messageType && messageType === 'error') {
      return message.error(error.message);
    }
  }

  render() {
    const { data, params, user } = this.props;
    const { userData, uid, favoriteChats } = user;
    const { activeChat, viewType } = this.state;

    let chatDataCurrent = data.allChats && data.allChats.find(chat => chat.chatId === params.id);

    let page = (
      <Layout className="messages page-wrapper">
        <Content className="feed">
          <PageHeader
            className="header"
            title="Messages"
            activeChat={activeChat}
            activeChatHandler={this.activeChatHandler}
            extra={
              <div className="search-form">
                <FilterPanel
                  filter={this.filterBy}
                  reverseRedirection="Messages"
                  deviceType
                />
              </div>
            }
            extraMobile={
              <Button type="primary" shape="circle" icon="search" />
            }
            mobileTitleSearch="User search"
            mobileTypeSearch="user"
            reverseRedirection="Messages"
          />

          <div className="page-content-inner page-messages">
            <Row
              className={`messages ${activeChat ? 'messages-chat-active' : ''}`}
              type="flex"
            >
              <Col xs={12} md={9} className="chats-list">
                <div className="chat-controls-container">
                  <div className="chat-controls">
                    <Search
                      placeholder="Search by user or content"
                      onChange={this.handleContactFilter}
                      value={this.state.filter}
                      style={{ width: '100%' }}
                    />
                    <div className="chat-filter-type">
                      <span
                        className={viewType === 'all' ? 'active' : ''}
                        onClick={this.handleViewTypeChange}
                      >
                        All
                      </span>
                      <span
                        className={viewType === 'favorite' ? 'active' : ''}
                        onClick={this.handleViewTypeChange}
                      >
                        Favorites
                      </span>
                    </div>
                  </div>
                </div>

                <ContactList
                  params={params}
                  uid={uid}
                  allChats={data.allChats}
                  handleChatChange={this.handleChatChange}
                  search={this.state.filter}
                  safeTofavoriteSwitcher={this.safeTofavoriteSwitcher}
                  favoriteChats={favoriteChats}
                  viewType={viewType}
                />
              </Col>
              <Col xs={12} md={15} className="current-chat-wrapper">
                {
                  chatDataCurrent && (
                    <Chat
                      chatData={chatDataCurrent}
                      currentUser={userData}
                      currentUid={uid}
                      sendChatMessageAction={this.props.sendChatMessageAction}
                    />
                  )
                }
              </Col>
            </Row>
          </div>
        </Content>
      </Layout>
    );
    if (!this.props.user || !this.props.user.uid) {
      page = (
        <React.Fragment>
          <PageHeader
            className="header"
            title="Messages"
            extra={
              <div className="search-form">
                <FilterPanel filter={this.filterBy} />
              </div>
            }
            extraMobile={
              <Button type="primary" shape="circle" icon="search" />
            }
            mobileTitleSearch="User search"
            mobileTypeSearch="user"
          />
          <div className="container">
            <AskForLogin
              page="Messages"
            />
          </div>
        </React.Fragment>
      )
    }

    return page;
  }
}

export default connect(
  null,
  {
    getChatAction,
    getUserChatsAction,
    sendChatMessageAction,
    moderateChatsAction,
    updateChatStatusAction,
    makeChatFavorite
  }
)(Messages);



// WEBPACK FOOTER //
// ./src/pages/Messages/index.js